import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ActivityService } from "src/app/core/services/activity.service";
import { ThemeService } from "src/app/core/services/theme.service";
import { CustomerSupportModeAlertComponent } from "../alerts/customer-support-mode-alert/customer-support-mode-alert.component";
import { PasswordExpiryAlertComponent } from "../alerts/password-expiry-alert/password-expiry-alert.component";
import { BottomMenuComponent } from "../bottom-menu/bottom-menu.component";
import { SideMenuComponent } from "../side-menu/side-menu.component";
import { TopbarComponent } from "../topbar/topbar.component";

@Component({
	selector: "app-main-layout",
	imports: [
		SideMenuComponent,
		TopbarComponent,
		RouterOutlet,
		BottomMenuComponent,
		PasswordExpiryAlertComponent,
		CustomerSupportModeAlertComponent,
	],
	templateUrl: "./main-layout.component.html",
})
export class MainLayoutComponent implements OnInit, OnDestroy {
	private activityService = inject(ActivityService);
	private theme = inject(ThemeService);

	ngOnInit(): void {
		this.theme.switchTheme("DEFAULT");
		this.activityService.checkForActivity();
	}

	ngOnDestroy(): void {
		this.activityService.stopCheckingForActivity();
	}
}
